/**
 * Service key constants matching backend service definitions
 * Matches: libs/go-core/auth/definitions.go
 */
export const SERVICE_KEY = {
  ADMIN: 'admin',
  AUTH: 'auth',
  EXPERT: 'expert',
  AUDIT: 'audit',
  TICKETING: 'ticketing',
} as const;

export type ServiceKey = (typeof SERVICE_KEY)[keyof typeof SERVICE_KEY];

/**
 * Array of all service keys
 */
export const SERVICE_KEYS = Object.values(SERVICE_KEY);

/**
 * Service action constants matching backend action definitions
 * Matches: libs/go-core/auth/action/action.go
 */
export const SERVICE_ACTION = {
  READ: 'read',
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
  ASSIGN: 'assign',
  APPROVE: 'approve',
  REJECT: 'reject',
} as const;

/**
 * Permission definition interface matching the backend Permission schema
 */
export interface Permission {
  service_key: string;
  resource: string;
  action: string;
}

/**
 * Permission metadata from API response
 */
export interface PermissionMetadataDTO {
  service_key: string;
  resource: string;
  action: string;
}

/**
 * Service key metadata from API response
 */
export interface ServiceKeyMetadataDTO {
  key: string;
  label: string;
  permissions: PermissionMetadataDTO[];
}

/**
 * Service keys metadata response from API
 */
export interface ServiceKeysMetadataResponseDTO {
  service_keys: ServiceKeyMetadataDTO[];
}
